import { kratosIntegration } from '@myme/utils';

export const handleVerifyUser = async () => {
  return kratosIntegration.request.toSession();
};
